// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__35gmm","inputWrap":"Table_inputWrap__3gtw8","col":"Table_col__2aPSW","bmiTooltip":"Table_bmiTooltip__1xNbx"};